import { Injectable } from '@angular/core';
import { UserAddress, UserDetails } from './inspector-api/inspector-api-contracts';
import { InspectorApiService } from './inspector-api/inspector-api.service';
import { Router } from '@angular/router';


interface AddressWithStatus extends UserAddress {
  _status?: 'new' | 'deleted' | 'existing';
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private isUserAuthenticated: boolean = false;
  private currentAddress: AddressWithStatus = {};
  private userDetails: UserDetails = {
    user: {},
    detail: {},
    addresses: []
  };

  constructor(private router: Router, private apiService: InspectorApiService) {}

  onLogin() {
    this.isUserAuthenticated = true;
  }

  onLogOut() {
    window.sessionStorage.setItem("userdetails","");
    window.sessionStorage.setItem("Authorization","");
    this.isUserAuthenticated = false;
  }

  onSignUp() {
    this.isUserAuthenticated = true;
  }

  isAuthenticated(): boolean {
    const userdetails = window.sessionStorage.getItem("userdetails");
    const token = window.sessionStorage.getItem("Authorization");
    // JWT is [header].[payload].[signature]
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]));
      // exp is in seconds; Date.now() is in milliseconds
      if((payload.exp * 1000) < Date.now()) {
        window.sessionStorage.clear();
        return false;
      }
    }
    
    if (userdetails && token)
      return true;

    return false;
  }

  administrator() {
    if (!this.userDetails) this.loadUserData();
    const value = this.userDetails.roleAccess?.filter(access => (access?.userRole?.role || "") === "ADMINISTRATOR");
    if (value)
      return value.length > 0;
    return false;
  }

  loadUserData() {
    // Try to load from localStorage first (from login)
    const storedUser = window.sessionStorage.getItem('userdetails');
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        this.userDetails = userData;
      } catch (e) {
        console.error('Error parsing user data:', e);
      }
    } else {
      this.router.navigate(['/login']);
    }
    try {
      // Format passport expiry date
      if (this.userDetails.detail?.passportExpiryDate) {
        this.userDetails.detail.passportExpiryDate = this.formatDateForInput(this.userDetails.detail.passportExpiryDate);
      }
      
      // Initialize arrays if they don't exist
      if (!this.userDetails.addresses) {
        this.userDetails.addresses = [];
      } else {
        // Mark existing addresses
        this.userDetails.addresses = this.userDetails.addresses.map(address => ({
          ...address,
          _status: 'existing'
        } as AddressWithStatus));
      }
    } catch (e) {
      console.error('Error parsing user data:', e);
    }
    return this.userDetails;
  }

  // Helper method to format date for HTML date input (YYYY-MM-DD)
  private formatDateForInput(dateString: string): string {
    if (!dateString) return '';
    
    // If already in YYYY-MM-DD format, return as is
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }
    
    // Parse ISO date and extract date portion
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return ''; // Invalid date
    }
    
    // Format as YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  }
  
}
